<template>
  <form @submit.prevent="submitForm">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Informations Générales</h1>
        <div class="py-2"></div>
        <InputComponent
          required
          label="Prénom"
          placeHolder="John"
          v-model="formData.firstName"
        />
        <InputComponent
          required
          label="Nom"
          placeHolder="Doe"
          v-model="formData.lastName"
        />
        <InputComponent
          required
          label="Email"
          placeHolder="johndoe@gmail.com"
          v-model="formData.email"
          :disabled="isEditing"
        />
        <InputComponent
          required
          label="Mot de passe"
          placeHolder="*********"
          v-model="formData.password"
          v-if="!isEditing"
        />
      </div>
      <div class="border bg-white rounded-3xl p-4">
        <h1 class="text-lg font-bold title-color">Permissions</h1>
        <div class="py-2"></div>

        <div>
          <div
            v-for="(permission, i) in allPermissions"
            :key="i"
            class="inline-block m-2 px-2 py-1 border rounded-full cursor-pointer"
            :class="{
              'border-primary shadow-xl': (
                formData.metadata?.permissions || []
              ).includes(permission.id),
            }"
            @click="togglePermission(permission.id)"
          >
            {{ $t(`permissions.${permission.id}`) }}
          </div>
        </div>
      </div>
    </div>

    <div class="py-4"></div>
    <div class="flex justify-center">
      <button type="submit" class="buttonComponent">
        {{ isEditing ? 'Mettre à jour' : 'Ajouter' }}
      </button>
    </div>
    <div class="pb-12"></div>
  </form>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '../utils/InputComponent.vue'
import allPermissions from '@/utils/raws/allPermissions.json'

export default defineComponent({
  name: 'ProductForm',
  components: {
    InputComponent,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        countryCode: '',
        metadata: {
          permissions: [],
        },
      }),
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { allPermissions, formData: { ...this.initialData } }
  },
  methods: {
    togglePermission(permission) {
      if (!Array.isArray(this.formData.metadata?.permissions)) this.formData.metadata.permissions = []
      const foundSizeIndex = this.formData.metadata.permissions.indexOf(permission)
      if (foundSizeIndex === -1) this.formData.metadata.permissions.push(permission)
      else this.formData.metadata.permissions.splice(foundSizeIndex, 1)
    },
    submitForm() {
      const data = {
        ...this.formData,
      }
      this.$emit('teammateSubmitted', data)
    },
  },
  computed: {},
  watch: {},
})
</script>

<style scoped></style>
